














































































import Vue, { PropType } from 'vue';
import Input from '../common/Input/Input.vue';
import Select from '../common/Select/Select.vue';
import LabelsetSchemaRulesView from './LabelsetSchemaRulesView.vue';
import Button from '../common/Button/Button.vue';
import CheckBox from '../common/CheckBox/CheckBox.vue';

interface labelDataI {
  labelName: string;
  example: string;
  dataType: string;
  ruleNum: number;
  depth: number;
  showRulePage: boolean;
  isRequired: boolean;
}

interface parsedObjectInfoI {
  name: string;
  type: string;
  example: string;
  depth: number;
}

interface valueI {
  pattern: string;
  category: string;
  minMax: {
    minimum: string | undefined;
    maximum: string | undefined;
  };
  minMaxElementNum: {
    minElementNum: string | undefined;
    maxElementNum: string | undefined;
  };
  elementUniqueness: boolean;
}

export default Vue.extend({
  props: {
    exampleData: {
      type: Array as PropType<parsedObjectInfoI[]>,
    },
    getResult: {
      type: Boolean,
    },
  },
  components: {
    Input,
    Select,
    LabelsetSchemaRulesView,
    Button,
    CheckBox,
  },
  data(): {
    computedData: labelDataI[];
    sortedRulesViewValue: { showRules: boolean[]; value: valueI }[];
  } {
    return {
      computedData: [],
      sortedRulesViewValue: [],
    };
  },
  created() {
    let initialComputedData: any = [];
    (this.exampleData as parsedObjectInfoI[]).forEach(
      (exampleRow: parsedObjectInfoI) => {
        initialComputedData.push({
          labelName: exampleRow.name,
          example: exampleRow.example,
          dataType: exampleRow.type,
          depth: exampleRow.depth,
          ruleNum: 0,
          showRulePage: false,
          isRequired: false,
        });
      },
    );
    this.computedData = initialComputedData;
  },
  methods: {
    onClickNextButton() {
      let labelSchema: {
        type: string;
        required?: string[];
        additionalProperties: boolean;
        properties: any;
      } = {
        type: 'object',
        properties: {},
        additionalProperties: true,
      };

      //
      const sortedRulesView: InstanceType<typeof LabelsetSchemaRulesView>[] = (
        this.$refs.rulesView as InstanceType<typeof LabelsetSchemaRulesView>[]
      ).sort(
        (
          a: InstanceType<typeof LabelsetSchemaRulesView>,
          b: InstanceType<typeof LabelsetSchemaRulesView>,
        ) => {
          const aIndex: number = parseInt(
            (a.$el as HTMLElement).dataset.index as string,
          );
          const bIndex: number = parseInt(
            (b.$el as HTMLElement).dataset.index as string,
          );
          return aIndex - bIndex;
        },
      );

      //각 rulesView에 속해 있는 instance에 대해 showRules와 value를 추출해낸다
      this.sortedRulesViewValue = sortedRulesView.reduce(
        (acc: { showRules: boolean[]; value: valueI }[], val) => {
          acc.push({
            showRules: val.showRules,
            value: val.value,
          });
          return acc;
        },
        [],
      );

      console.log(this.sortedRulesViewValue);
      const { value: properties, required: required } =
        this.normalizeValueToJSON(0, this.computedData[0].depth, false);
      labelSchema.properties = properties;
      if (required.length !== 0) {
        labelSchema.required = required;
      }
      console.log(labelSchema);

      this.$emit('pushResult', { ok: true, labelSchema, properties });
    },
    normalizeValueToJSON(
      currentIndex: number,
      currentDepth: number,
      isParentArray: boolean,
    ): { value: any; required: string[]; index: number } {
      let responseValue: any = {};
      let required: string[] = [];
      let index = currentIndex;

      //index가 length를 넘지 않을 때까지 반복
      while (index < this.computedData.length) {
        console.log(currentIndex, currentDepth, isParentArray);
        if (this.computedData[index].depth < currentDepth) {
          //currentDepth보다 다음 index의 depth가 작을 경우
          //상위 단계의 data로 이동했다는 이야기이기 때문에 바로 break
          break;
        } else if (this.computedData[index].depth === currentDepth) {
          //currentDepth와 동일한 depth의 index일 경우, normalizing을 시작한다

          if (isParentArray) {
            //만약 Parent가 Array일 경우 labelName을 생략해서 넘겨줘야 한다
            const showRules = this.sortedRulesViewValue[index].showRules;
            const value = this.sortedRulesViewValue[index].value;

            if (showRules[0]) {
              responseValue['pattern'] = value.pattern;
            }
            if (showRules[1]) {
              responseValue['enum'] = value.category.split('/');
            }
            if (showRules[2]) {
              if (value.minMax.minimum !== undefined) {
                responseValue['minimum'] = parseInt(value.minMax.minimum);
              }

              if (value.minMax.maximum !== undefined) {
                responseValue['maximum'] = parseInt(value.minMax.maximum);
              }
            }
            if (showRules[3]) {
              if (value.minMaxElementNum.minElementNum !== undefined) {
                responseValue['minItems'] = parseInt(
                  value.minMaxElementNum.minElementNum,
                );
              }
              if (value.minMaxElementNum.maxElementNum !== undefined) {
                responseValue['maxItems'] = parseInt(
                  value.minMaxElementNum.maxElementNum,
                );
              }
            }
            if (showRules[4]) {
              responseValue['uniqueItems'] = true;
            }
            responseValue['type'] = this.computedData[index].dataType;

            let nextIndex = index + 1;
            if (this.computedData[index].dataType === 'object') {
              const {
                value: subResponseValue,
                index: subNextIndex,
                required: subRequired,
              } = this.normalizeValueToJSON(index + 1, currentDepth + 1, false);

              if (subResponseValue !== {}) {
                responseValue.properties = subResponseValue;
              }
              if (subRequired.length > 0) {
                responseValue.required = subRequired;
              }
              nextIndex = subNextIndex;
            } else if (this.computedData[index].dataType === 'array') {
              const { value: subResponseValue, index: subNextIndex } =
                this.normalizeValueToJSON(index + 1, currentDepth + 1, true);

              if (subResponseValue !== {}) {
                responseValue.items = subResponseValue;
              }
              nextIndex = subNextIndex;
            }
            index = nextIndex;
            //Parent가 Array일 경우 item은 한 가지 종류만 존재할 수 있기 때문에 바로 break한다
            break;
          } else {
            //만약 Parent가 Array가 아닐 경우 labelName을 key, option을 value로 넘겨줘야 한다
            const showRules = this.sortedRulesViewValue[index].showRules;
            const value = this.sortedRulesViewValue[index].value;

            let oneResponseValue: any = {};

            if (showRules[0]) {
              oneResponseValue['pattern'] = value.pattern;
            }
            if (showRules[1]) {
              oneResponseValue['enum'] = value.category.split('/');
            }
            if (showRules[2]) {
              if (value.minMax.minimum !== undefined) {
                oneResponseValue['minimum'] = parseInt(value.minMax.minimum);
              }

              if (value.minMax.maximum !== undefined) {
                oneResponseValue['maximum'] = parseInt(value.minMax.maximum);
              }
            }
            if (showRules[3]) {
              if (value.minMaxElementNum.minElementNum !== undefined) {
                oneResponseValue['minItems'] = parseInt(
                  value.minMaxElementNum.minElementNum,
                );
              }
              if (value.minMaxElementNum.maxElementNum !== undefined) {
                oneResponseValue['maxItems'] = parseInt(
                  value.minMaxElementNum.maxElementNum,
                );
              }
            }
            if (showRules[4]) {
              oneResponseValue['uniqueItems'] = true;
            }

            oneResponseValue['type'] = this.computedData[index].dataType;
            if (this.computedData[index].isRequired) {
              required.push(this.computedData[index].labelName);
            }

            let nextIndex = index + 1;
            if (this.computedData[index].dataType === 'object') {
              const {
                value: subResponseValue,
                index: subNextIndex,
                required: subRequired,
              } = this.normalizeValueToJSON(index + 1, currentDepth + 1, false);

              if (subResponseValue !== {}) {
                oneResponseValue.properties = subResponseValue;
              }
              if (subRequired.length > 0) {
                oneResponseValue.required = subRequired;
              }
              nextIndex = subNextIndex;
            } else if (this.computedData[index].dataType === 'array') {
              const { value: subResponseValue, index: subNextIndex } =
                this.normalizeValueToJSON(index + 1, currentDepth + 1, true);

              if (subResponseValue !== {}) {
                oneResponseValue.items = subResponseValue;
              }
              nextIndex = subNextIndex;
            }

            responseValue[this.computedData[index].labelName] =
              oneResponseValue;
            index = nextIndex;
          }
        }
      }

      return {
        value: responseValue,
        index: index,
        required: required,
      };
    },
    onClickShowRulePageButton(target: HTMLElement) {
      if (!target.dataset.index) {
        return;
      }

      const index = parseInt(target.dataset.index);

      this.computedData[index]['showRulePage'] =
        !this.computedData[index]['showRulePage'];
    },
  },
  watch: {
    getResult: function (getResult) {
      if (getResult === true) {
        this.onClickNextButton();
      }
    },
  },
});
